/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { getCurrentClientData } from "@/services/authServices";
import type { ApiRequestOptions } from "./ApiRequestOptions";

type Resolver<T> = (options: ApiRequestOptions) => Promise<T>;
type Headers = Record<string, string>;

export type OpenAPIConfig = {
  BASE: string;
  VERSION: string;
  WITH_CREDENTIALS: boolean;
  CREDENTIALS: "include" | "omit" | "same-origin";
  TOKEN?: string | Resolver<string> | undefined;
  USERNAME?: string | Resolver<string> | undefined;
  PASSWORD?: string | Resolver<string> | undefined;
  HEADERS?: Headers | Resolver<Headers> | undefined;
  ENCODE_PATH?: ((path: string) => string) | undefined;
};
const environment = localStorage.getItem("app_environment");

export const OpenAPI: OpenAPIConfig = {
  BASE: import.meta.env.VITE_API_BASE_URL,
  VERSION: "1.0.0",
  WITH_CREDENTIALS: false,
  CREDENTIALS: "include",
  TOKEN: undefined,
  USERNAME: undefined,
  PASSWORD: undefined,
  HEADERS: {
    Authorization: `${getCurrentClientData()?.token}`,
  } as Headers,
  ENCODE_PATH: undefined,
};

export const OpenCecureEventAPI: OpenAPIConfig = {
  BASE: import.meta.env.VITE_CECURESTREAM_MEETING,

  // BASE: "https://api.dev.cecurestream.com",

  VERSION: "1.0.0",
  WITH_CREDENTIALS: false,
  CREDENTIALS: "include",
  TOKEN: undefined,
  USERNAME: undefined,
  PASSWORD: undefined,
  HEADERS: {
    Authorization: `${getCurrentClientData()?.token}`,
  } as Headers,
  ENCODE_PATH: undefined,
};
